import { ContentItem } from "../ContentItem/ContentItem";
import { ContentParent } from "../ContentParent";
import { Translate } from "components/common/Translate/Translate";
import { ResizeIcon } from "components/common/Icons/ResizeIcon";
import { HeartIcon } from "components/common/Icons/HeartIcon";
import { LightningFastIcon } from "components/common/Icons/LightningFastIcon";

export const RotateContent = () => {
    return (
        <div className="mx-auto my-20" style={{ maxWidth: "840px" }}>
            <ContentParent>
                <ContentItem
                    title={<Translate keyName="content-easy-title" />}
                    description={<Translate keyName="content-easy-sub-title" />}
                    icon={<LightningFastIcon />}
                />
                <ContentItem
                    title={<Translate keyName="content-straighten-title" />}
                    description={<Translate keyName="content-straighten-sub-title" />}
                    icon={<ResizeIcon width={30} height={30} />}
                />
                <ContentItem
                    title={<Translate keyName="content-free-title" />}
                    description={<Translate keyName="content-free-sub-title" />}
                    icon={<HeartIcon />}
                />
            </ContentParent>
        </div>
    );
};
